<template>
  <div :class="this.visible?'show':''" class="modal fade" tabindex="-1" role="dialog"
       aria-labelledby="exampleModalLabel"
       aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <div class="modal-title">提醒您</div>
        </div>
        <div class="modal-body">
          <p class="text_style">{{ text }}</p>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn_style btn-white" @click="clickCancel">取消</button>
          <button type="button" class="btn btn_style btn-primary" @click="clickConfirm">確認</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ActionDialog",
  props: {
    visible: {
      type: Boolean,
      default: false
    }, text: {
      type: String,
    }
  },
  watch: {
    visible(val) {
      this.visible = val;
    },
  },
  methods: {
    clickCancel() {
      this.visible = false;
      this.$emit('submit', false);
    },
    clickConfirm() {
      this.visible = false;
      this.$emit('submit', true);
    },
  },
}
</script>

<style scoped>
.modal-content {
  border-radius: 10px;
}

.modal-header {
  background-color: #D56835;
  border-radius: 10px 10px 0 0;
  height: 48px;
  padding: 9px 18px;
  margin: 0;
  display: block;
}

.modal-title {
  font-family: Noto Sans TC;
  font-size: 24px;
  font-weight: 500;
  letter-spacing: 0.1em;
  text-align: left;
  padding: 0;
  margin: 0;
  color: #FFFFFF;
}

.icon {
  content: url('/img/image/icon/dot.png');
  width: 12px;
  height: 11px;
  margin-right: 8px;
}

.text_style {
  font-family: Noto Sans TC;
  font-size: 20px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.1em;
  text-align: left;
  margin-top: 0;
  margin-bottom: 8px;
  color: black;
}

.modal-footer {
  height: 105px;
  border: none;
}

.btn_style {
  width: 100px;
  height: 53px;
  font-family: Noto Sans TC;
  font-size: 24px;
  font-weight: 500;
  border-radius: 10px;
  text-align: center;
  padding: 0;
  /*margin: 0;*/
}

.show {
  display: block;
}

.modal {
  z-index: 2000;
}

</style>
